import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './Toast.css';
import { showMessageToast } from '../../Pages/Login/Login.reducer';
import tick from '../../Images/Icons/tick.svg';
import remove from '../../Images/Icons/remove.svg';

class MessageToast extends Component {
  componentWillReceiveProps(nextProps) {
    const { show } = this.props.messageToast;
    if (show !== nextProps.messageToast.show && nextProps.messageToast.show) {
      setTimeout(() => this.close(), 3000);
    }
  }

  close = () => {
    this.props.showMessageToast({
      show: false,
      message: '',
      type: '',
    });
  };

  render() {
    const { messageToast } = this.props;
    return (
      <>
        {messageToast.show && (
          <div className="toastContainer">
            <div
              className={`toastIndicator ${
                messageToast.type === 'success' ? 'success' : 'error'
              }`}
            />
            <div className="iconContainer">
              <img
                src={messageToast.type === 'success' ? tick : remove}
                className="iconStyles"
              />
            </div>
            <span className="toastMessage">{messageToast.message}</span>
            <span onClick={this.close} className="flaticon-close" />
          </div>
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({
    messageToast: state.loginReducer.messageToast,
  }),
  {
    showMessageToast,
  }
)(MessageToast);
